<template>
<div style="margin-left:12.5%;margin-right:12.5%;background-color:#ffffff;border:1px solid #eeeeee;">
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="margin:0 auto;text-align:center;">
        <el-table
            :data="config_info"
            border
            stripe
            style="width:800px;">
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="sys_version" label="系统" min-width="10%"></el-table-column>
            <el-table-column prop="user_cur_count" label="当前用户数" min-width="25%"></el-table-column>
            <el-table-column prop="user_limit_count" label="限定用户数" min-width="25%">
                <template slot-scope="scope">
                    <el-input v-if="modify_status=='adjust'" v-model="scope.row.user_limit_count"></el-input>
                    <span v-else>{{ scope.row.user_limit_count }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="user_left_count" label="剩余用户数" min-width="25%"></el-table-column>
            <el-table-column prop="operation" label="操作" min-width="10%">
                <template slot-scope="scope">
                    <el-button v-if="modify_status=='finish'"
                    size="mini"
                    type="warning"
                    @click="adjMaxUser(scope.row)">调整</el-button>
                    <el-button v-else
                    size="mini"
                    type="primary"
                    @click="adjMaxUser(scope.row)">确定</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</div>
</template>

<script>
import getdata from "@/api/getData.js";
export default {
    created() {
        getdata.getList("checklogin")
              .then((resp) => {
                this.task_id = resp.data.task_id;
                // 当前页面仅限企业用户登录
                if(resp.data.usertype!='sadmin'){
                    this.$router.push({
                    path: '/404',
                });
                }else{
                    if(this.$route.path.includes('/RC')) {
                        this.system_type = '3.0';
                    }else if(this.$route.path.includes('/JK')) {
                        this.system_type = '2.0';
                    }else{
                        this.system_type = '1.0';
                    }
                    this.initSysConfig();
                }
              })
              .catch(() => {
                // if(localStorage.getItem("token") != null){
                //     this.$message({
                //         message: '会话超时，请重新登录！',
                //         type: 'warning',
                //     })
                // }
                this.$router.push({
                    path: '/404',
                });
              })
    },
    data() {
        return {
            system_type: '',
            modify_status: 'finish',
            config_info: [],
        };
    },
    methods: {
        initSysConfig() {
            getdata.getList("initSysConfig")
            .then(resp => {
                if(resp.data.code == 200){
                    this.getUserCountLimit();
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 6000,
                        // showClose: true,
                    })
                }
            })
            .catch(() => {

            });
        },
        getUserCountLimit() {
            let params = {
                    'sys_version': this.system_type,
                };
            getdata.getListP("getUserCountLimit", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.config_info = resp.data.data;
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 6000,
                        // showClose: true,
                    })
                }
            })
            .catch(() => {

            });
        },
        adjMaxUser(row) {
            if(this.modify_status=='finish'){
                this.modify_status = 'adjust';
                return;
            }else{
                let params = {
                    'sys_version': row.sys_version,
                    'user_limit_count': row.user_limit_count
                };
                getdata.getListP("adjustUserCountLimit", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.modify_status = 'finish';
                        this.getUserCountLimit();
                    }else{
                        this.$message({
                            message: resp.data.message,
                            type: "error",
                            duration: 6000,
                            // showClose: true,
                        })
                    }
                })
                .catch(() => {

                });
            }
        }
    }
}
</script>

<style scoped>
.el-breadcrumb {
    font-size: 20px;
    border-left: solid 6px #606266;
    padding-left: 15px;
    margin-bottom: 50px;
}
.top_buttons > .el-button {
    font-size: 16px;
}
</style>

